import { atom } from "recoil"

export const groupsRequestIdState = atom({
  key: "atoms/organization/group/groupsRequestIdState",
  default: 0,
})
